var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrow(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 26,
    height: 21,
    viewBox: "0 0 26 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8387 9.81254C25.0377 10.0118 25.1494 10.2818 25.1494 10.5634C25.1494 10.8449 25.0377 11.115 24.8387 11.3142L16.3387 19.8142C16.2414 19.9186 16.1241 20.0023 15.9938 20.0604C15.8634 20.1185 15.7228 20.1497 15.5801 20.1522C15.4374 20.1547 15.2957 20.1285 15.1634 20.075C15.0311 20.0216 14.9109 19.9421 14.81 19.8412C14.7092 19.7403 14.6296 19.6201 14.5762 19.4878C14.5227 19.3555 14.4965 19.2138 14.499 19.0711C14.5015 18.9285 14.5328 18.7878 14.5908 18.6574C14.6489 18.5271 14.7326 18.4098 14.837 18.3125L21.5237 11.6259L1.42118 11.6259C1.13939 11.6259 0.869138 11.5139 0.669881 11.3147C0.470623 11.1154 0.358682 10.8452 0.358682 10.5634C0.358682 10.2816 0.470623 10.0113 0.669881 9.81207C0.869138 9.61281 1.13939 9.50087 1.42118 9.50087L21.5237 9.50087L14.837 2.8142C14.7326 2.71693 14.6489 2.59963 14.5908 2.4693C14.5328 2.33896 14.5015 2.19827 14.499 2.05561C14.4965 1.91295 14.5227 1.77124 14.5762 1.63894C14.6296 1.50664 14.7092 1.38646 14.81 1.28556C14.9109 1.18467 15.0311 1.10513 15.1634 1.05169C15.2957 0.998256 15.4374 0.972013 15.5801 0.97453C15.7228 0.977047 15.8634 1.00827 15.9938 1.06634C16.1241 1.12442 16.2414 1.20814 16.3387 1.31253L24.8387 9.81254Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrow);
export default __webpack_public_path__ + "static/media/arrow.0a495ab84735de6379553ce5fd0ca52e.svg";
export { ForwardRef as ReactComponent };